/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc base64形式上传文件
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  base64FileUploadDto: oss.Base64FileUploadDto,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: string;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/oss/file/base64`,
    data: base64FileUploadDto,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
